import { useEffect } from 'react';

const SITE = 'https://secondlifesoftware.com';

// Find-or-create a <meta> tag and set its content. Used so each route can
// publish its own title/description/OG tags. react-snap snapshots the DOM
// after effects run, so these end up in the prerendered static HTML and are
// picked up by search engines and social-share crawlers.
function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href) {
  if (!href) return;
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

// Set per-page SEO metadata. `path` should start with "/" (e.g. "/blog").
export default function usePageMeta({ title, description, path } = {}) {
  useEffect(() => {
    if (title) {
      document.title = title;
      upsertMeta('property', 'og:title', title);
      upsertMeta('name', 'twitter:title', title);
    }
    if (description) {
      upsertMeta('name', 'description', description);
      upsertMeta('property', 'og:description', description);
      upsertMeta('name', 'twitter:description', description);
    }
    if (path) {
      const url = `${SITE}${path}`;
      upsertMeta('property', 'og:url', url);
      upsertCanonical(url);
    }
  }, [title, description, path]);
}
